import { render, staticRenderFns } from "./ServiceCompanyPermissionsPage.vue?vue&type=template&id=2063a60c"
import script from "./ServiceCompanyPermissionsPage.vue?vue&type=script&lang=js"
export * from "./ServiceCompanyPermissionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports